import { Component, Input, ViewChild, ElementRef, input, computed, effect } from '@angular/core'
import { PricingRowVM } from '../vetcor-pricing-row.model'
import { VetcorPricingRowService } from '../vetcor-pricing-row.service'
import { Observable, Subject } from 'rxjs'
import { HospitalPricingService } from '../../hospital-pricing.service'
import { PricingRowFunctions } from '../pricing-row-functions'

@Component({
   selector: 'vetcor-pricing-row',
   templateUrl: './vetcor-pricing-row.component.html',
   styleUrls: ['./vetcor-pricing-row.component.scss'],
   standalone: false,
})
export class VetcorPricingRowComponent {
   @Input() canViewDetails: boolean

   @ViewChild('rationaleInput') rationaleInput!: ElementRef<HTMLTextAreaElement>
   @ViewChild('newPrice') newPriceInput!: ElementRef<HTMLInputElement>

   showPracticeColumn = input<boolean>(false)
   isRequestView = input<boolean>(false)

   displaySites = input<boolean>(false)
   displayAsReview = input<boolean>(false)
   row = input<PricingRowVM>()
   activeCycle = this.hospitalPricingService.activeCycle
   isHighlighted = computed(() => this.row().newPrice > 0 || this.row().opsPrice > 0)

   constructor(public pricingService: VetcorPricingRowService, public hospitalPricingService: HospitalPricingService) {}

   focusNewPrice(): HTMLInputElement {
      this.newPriceInput?.nativeElement?.focus()
      this.newPriceInput?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return this.newPriceInput?.nativeElement
   }

   focusRationaleInput(): HTMLTextAreaElement {
      this.rationaleInput?.nativeElement?.focus()
      this.rationaleInput?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return this.rationaleInput?.nativeElement
   }

   focusInvalidField(): string {
      if (PricingRowFunctions.hasMissingRationale(this.row()) || this.row().subRows.some((sr) => PricingRowFunctions.hasMissingRationale(sr))) {
         this.focusRationaleInput()
         return 'Rationale is required to continue'
      }
      if (PricingRowFunctions.hasInvalidNumber(this.row()) || this.row().subRows.some((sr) => PricingRowFunctions.hasInvalidNumber(sr))) {
         this.focusNewPrice()
         return 'Incorrect format. Only use numbers'
      }

      return undefined
   }

   onInputClick(event: Event): void {
      event.stopPropagation()
   }

   isValidRationale(forOps: boolean): boolean {
      if (forOps) {
         return !(this.row().opsPrice && (!this.row().finalComment || !this.row().finalComment.trim()))
      } else {
         return !(this.row().newPrice && (!this.row().rationale || !this.row().rationale.trim()))
      }
   }

   toggleExpand(group) {
      this.pricingService.toggleExpand(group)
   }
}
